<era-pane>
  <h5 class="small-caps"
      i18n>Personal Hotspot</h5>
  <form [formGroup]="personalHotspotForm"
        (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <div class="form-check form-switch">
        <input type="checkbox"
               class="form-check-input rounded-3"
               role="switch"
               formControlName="personalHotspotEnabled"
               id="personalHotspotEnabled" />
        <label class="form-check-label"
               for="personalHotspotEnabled">Turn Personal Hotspot {{ (personalHotspotEnabled.valueChanges | async) ?
          'On' : 'Off' }}</label>
        <small class="form-text text-muted"> The Personal Hotspot setting is only available on certain carriers.</small>
      </div>
    </div>
    <button class="btn btn-primary"
            type="submit"
            [disabled]="!personalHotspotForm.valid">Submit</button>
  </form>
</era-pane>